import { InitProps, ParamsTrackerContext } from "../types";
import { log } from "./log";
import { applyUTMsToLinksAndForms } from "./applyUTMs";
import { observeDynamicElements } from "./domWatcher";
import { retryApplyUTMs } from "./retryApply";

let isInitialized = false;

export class UTMSInit {
  private config: Required<InitProps>;

  constructor(config: InitProps) {
    this.config = {
      delay: 0,
      debug: false,
      enabled: true,
      ...config,
    };

    this.init();
  }

  private getContext(): ParamsTrackerContext {
    return {
      config: this.config,
    };
  }

  private init(): void {
    if (typeof window === "undefined") return;

    log({
      debug: this.config.debug,
      message: "Inicializando Params Tracker",
    });

    if (this.config.enabled) {
      if (!isInitialized) {
        applyUTMsToLinksAndForms({ debug: this.config.debug });
        observeDynamicElements({ debug: this.config.debug });
        retryApplyUTMs({ debug: this.config.debug });

        isInitialized = true;
      }
    }
  }
}
